<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['create']);
const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col items-center justify-center py-16 text-center">
    <div
      class="w-24 h-24 mb-6 rounded-full bg-n-alpha-2 flex items-center justify-center"
    >
      <span class="i-lucide-megaphone text-4xl text-n-slate-9" />
    </div>
    <h3 class="text-lg font-semibold text-n-slate-12 mb-2">
      {{ t('WHATSAPP_BROADCAST.EMPTY_STATE.TITLE') }}
    </h3>
    <p class="text-sm text-n-slate-11 max-w-md mb-6">
      {{ t('WHATSAPP_BROADCAST.EMPTY_STATE.SUBTITLE') }}
    </p>
    <Button icon="i-lucide-plus" color-scheme="primary" @click="emit('create')">
      {{ t('WHATSAPP_BROADCAST.NEW_CAMPAIGN') }}
    </Button>
  </div>
</template>
